export { default } from './CollapsedMultiValue';
